var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSatisfaction2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.4 56.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "satisfaction_2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1028.3-203.42c-7.55,6.32-17.36,6.74-26.14,2.52-7.08-3.4-14.16-10.76-15.39-20.56-1.39-11,6.34-21.7,14.34-23.89,8.81-2.42,18.81,3.56,25.17,11.68,7.23,9.24,9.34,23,1.52,31.66-.25.28-1.9,2.1-.87,2.58s2.52-.77,3.18-1.51c6.62-7.34,9.67-17.41,5.3-28.42-4-10-12.61-17.24-21-19.76-10.15-3.06-19,2.26-25.88,10.74-5.52,6.8-8.57,16.54-4.84,26.29,3.46,9.07,11.48,14.75,18.86,17,9.49,2.93,19.17.23,26.88-6.23.45-.37,2.24-1.88,1.69-2.89s-2.39.4-2.83.77",
    transform: "translate(-982.06 250)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1018-231.73a23.19,23.19,0,0,0,.55,8.33c.34,1.25,4.2-1.17,3.71-3a21.37,21.37,0,0,1-.4-7.68c.1-1.17-1.69-.34-1.95-.18a3.63,3.63,0,0,0-1.91,2.53",
    transform: "translate(-982.06 250)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M998.26-231.42a14.05,14.05,0,0,0-.37,8.94c.27,1,4.15-1.35,3.71-3a12.08,12.08,0,0,1,.32-7.69c.41-1.13-.88-.8-1.28-.61a4.62,4.62,0,0,0-2.38,2.35",
    transform: "translate(-982.06 250)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1018.87-211.39c-2.41,2.93-5.12,5.47-8.74,5.2-3.4-.26-6.3-3.3-8.5-6.43-1.08-1.54-4.65,1.64-3.7,3,2.93,4.16,6.74,7.54,11.21,7.22,4.7-.35,8.69-3.65,11.9-7.57,2.12-2.59-.7-3.2-2.17-1.41",
    transform: "translate(-982.06 250)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatisfaction2);
export default __webpack_public_path__ + "static/media/satisfaction_2.230dc2f7.svg";
export { ForwardRef as ReactComponent };